import React, { Component, useDebugValue, useState, useRef, useCallback, useEffect, act } from 'react';
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { useTranslateText } from "../../hooks/userLanguageTranslate";
import { API_GATEWAY_URL } from '../../config/constants';
import axios from 'axios';
import _ from "lodash";
import CookieUtil from "../../utils/cookieUtil";
import UserHelper from '../../common/utils/userHelper';

interface Translation {
  key: string;
  title?: string;
  description?: string;
}

interface Speaker {
  first_name?: string;
  last_name?: string;
  profile_picture?: {
      key?: string;
  };
}
interface ScheduleItem {
  speaker?: Speaker;
  moderator?: Speaker;
  translations?: Translation[];
  start_time?: string;
  end_time?: string;
}
const LandingPageSchedules: React.FC = () => {

  const [lang_name, setLang_name]     = useState(null);
  const eventData = useSelector((state: RootState) => state.eventData);
  const homePage  = useSelector((state: RootState) => state.homePage);
  const [schedules, setSchedules] = useState({});
  const [livePresentations, setLivePresentations] = useState<ScheduleItem[]>([]);
  const [roundTables, setRoundTables] = useState<ScheduleItem[]>([]);
  const [panelDiscussions, setPanelDiscussions] = useState<ScheduleItem[]>([]);
  const [onDemand, setonDemand] = useState<ScheduleItem[]>([]);
  const [displayCenter, setDisplayCenter] = useState<ScheduleItem[]>([]);
 

    // const [activeTab, setActiveTab] = useState(getDefaultTab());

  const translateEventSchedule    =     useTranslateText('nav-event-schedule', 'EVENT SCHEDULE');
  const translateLivePresentation =     useTranslateText('live-presentation', 'Live Presentation');
  const translatePanelDiscussion  =     useTranslateText('panel-discussion', 'Panel Discussion');
  const translateOndemand         =     useTranslateText('on-demand-presentation',"On Demand");
  const translateRoundTable       =     useTranslateText('virtual-round-table','Virtual Round Table')
  const translateLocalTime        =     useTranslateText('local-time', 'Local Time');


  // 
  const [activePanel, setActivePanel]                   = useState<number | null>(null);
  const [activeLivePanel, setActiveLivePanel]           = useState<number | null>(null);
  const [activeRoundTable, setActiveRoundTable]         = useState<number | null>(null);
  const [activeOnDemand, setActiveOnDemand]             = useState<number | null>(null);
  const [activeDisplayCenter, setActiveDisplayCenter]  = useState<number | null>(null);

  
  
  useEffect(() => {
    let lang_name:any = CookieUtil.readCookie('lang_name');
    setLang_name(lang_name)

    const url = API_GATEWAY_URL + 'frontend/api/events/' + eventData._id + '/schedules/';
    axios.get(url)
        .then((response) => {
            setSchedules(_.get(response, 'data.data', []));
        })
        .catch((e) => {
            console.error(e);
        });
  }, []);

  useEffect(() => {
    const filter:any = _.get(homePage, 'schedule_filter', []);
    console.log("filterfilter",filter);
    
    setLivePresentations(_.flatten(filter.data));
    setRoundTables(_.flatten(filter.dataRoundTable));
    setPanelDiscussions(_.flatten(filter.dataPanelDiscussion));
    setonDemand(_.flatten(filter.dataOnDemand));
    setDisplayCenter(_.flatten(filter.dataDisplayCenter))
    
}, [schedules, homePage]);
      
        const hasData = (tabName: string) => {
            switch (tabName) {
              case "live":
                return _.isArray(livePresentations) && _.size(livePresentations) > 0;
              case "ondemand":
                return _.isArray(onDemand) && _.size(onDemand) > 0;
              case "round":
                return _.isArray(roundTables) && _.size(roundTables) > 0;
              case "panel":
                return _.isArray(panelDiscussions) && _.size(panelDiscussions) > 0;
              case "display":
                return _.isArray(displayCenter) && _.size(displayCenter) > 0;

              default:
                return false;
            }
        };
          

        
      
        const handleTabClick = (tabName: string) => {
            
          if (hasData(tabName)) {
            setActiveTab(tabName);
          }
        };

        const [activeTab, setActiveTab] = useState<string>("live"); // Start with a default

        useEffect(() => {
          const getDefaultTab = () => {
            if (_.isArray(livePresentations) && livePresentations.length > 0) return "live";
            if (_.isArray(onDemand) && onDemand.length > 0) return "ondemand";
            if (_.isArray(roundTables) && roundTables.length > 0) return "round";
            if (_.isArray(panelDiscussions) && panelDiscussions.length > 0) return "panel";
            if (_.isArray(displayCenter) && displayCenter.length > 0) return "display";
            return "live";
          };
        
          setActiveTab(getDefaultTab());
        }, [livePresentations, onDemand, roundTables, panelDiscussions]);    
  return (
<div className="tab-content">
  {/* Live Presentations */}
  {_.size(livePresentations) > 0 && (
    <div className="event-section">
      <h2 className="section-heading">Live Presentations</h2>
      {_.map(livePresentations, (lp: any, key) => (
        <div
          key={key}
          className={`event ${activeLivePanel === key ? "extend" : ""}`}
        >
          {/* Time */}
          <div
            className="time"
            style={{ color:eventData.primary_color }}
            onClick={() =>
              setActiveLivePanel(activeLivePanel === key ? null : key)
            }
          >
            {UserHelper.localTimeStrFromZone(lp.start_time)} -{" "}
            {UserHelper.localTimeStrFromZone(lp.end_time)}
            <span style={{ backgroundColor:eventData.primary_color }}>
            <i
            className={
            activeLivePanel === key
            ? "icon-up-open-2"   // when active (expanded)
            : "icon-down-open-2" // when collapsed
            }
            ></i>
            </span>
          </div>

          {/* Info */}
          <div className="info" style={{ borderLeft:'2px solid' + eventData.primary_color }}>
            <h3 style={{ color:eventData.primary_color }}>{UserHelper.getEventTitle(lp.translations)}</h3>
            <p className="name">
              <strong className="strongP" style={{ color:eventData.primary_color }}>{UserHelper.getEventSpeaker(lp)}  </strong>
              <br/>{UserHelper.getSpeakerProfession(lp)}
              <br />


              {activeLivePanel !== key && (
    <div
      onClick={() =>
        setActiveLivePanel(activeLivePanel === key ? null : key)
      }
    >
      <a href="#_" className="about-more" style={{ color:eventData.primary_color }}>
        More
        <i className="icon-right-open"></i>
      </a>
    </div>
  )}

          
            </p>

           

            {activeLivePanel === key && (
              <div className="caption">
                <div className="image-area">
                  <img
                    src={UserHelper.getSpeakerPicture(lp)}
                    alt="speaker"
                    width="150"
                  />
                </div>
                <div className="text-area">
                  <p
                    dangerouslySetInnerHTML={{
                      __html: UserHelper.getEventDescription(lp),
                    }}
                  />
                </div>
              </div>
            )}
            <hr />
          </div>
        </div>
      ))}
    </div>
  )}

  {/* Round Tables */}
  {_.size(roundTables) > 0 && (
    <div className="event-section">
      <h2 className="section-heading">Round Tables</h2>
      {_.map(roundTables, (rt, key) => (
        <div
          key={key}
          className={`event ${activeRoundTable === key ? "extend" : ""}`}
        >
          <div
            className="time"
            style={{ color:eventData.primary_color }}
            onClick={() =>
              setActiveRoundTable(activeRoundTable === key ? null : key)
            }
          >
            {UserHelper.localTimeStrFromZone(rt.start_time)} -{" "}
            {UserHelper.localTimeStrFromZone(rt.end_time)}
            <span style={{ backgroundColor:eventData.primary_color }}>
            <i
            className={
            activeRoundTable === key
            ? "icon-up-open-2"   // when active (expanded)
            : "icon-down-open-2" // when collapsed
            }
            ></i>
            </span>
          </div>
          <div className="info" style={{ borderLeft:'2px solid' + eventData.primary_color }}>
            <h3 style={{ color:eventData.primary_color }} >{UserHelper.getEventTitle(rt.translations)}</h3>
            <p className="name">
              <strong className="strongP" style={{ color:eventData.primary_color }}>{UserHelper.getEventSpeaker(rt)}  </strong>
              <br/>{UserHelper.getSpeakerProfession(rt)}
               <br />



                {activeRoundTable !== key && (
    <div
      onClick={() =>
        setActiveRoundTable(activeRoundTable === key ? null : key)
      }
    >
      <a href="#_" className="about-more" style={{ color:eventData.primary_color }}>
        More
        <i className="icon-right-open"></i>
      </a>
    </div>
  )}




              
               
               
               
               
              
             
            </p>

            {activeRoundTable === key && (
              <div className="caption">
                <div className="image-area">
                  <img
                    src={UserHelper.getSpeakerPicture(rt)}
                    alt="speaker"
                    width="150"
                  />
                </div>
                <div className="text-area">
                  <p
                    dangerouslySetInnerHTML={{
                      __html: UserHelper.getEventDescription(rt),
                    }}
                  />
                </div>
              </div>
            )}
            <hr />
          </div>
        </div>
      ))}
    </div>
  )}

  {/* Panel Discussions */}
  {_.size(panelDiscussions) > 0 && (
    <div className="event-section">
      <h2 className="section-heading">Panel Discussions</h2>
      {_.map(panelDiscussions, (pd, key) => (
        <div
          key={key}
          className={`event ${activePanel === key ? "extend" : ""}`}
        >
          <div
            className="time"
            onClick={() => setActivePanel(activePanel === key ? null : key)}
            style={{ color:eventData.primary_color }}
          >
            {UserHelper.localTimeStrFromZone(pd.start_time)} -{" "}
            {UserHelper.localTimeStrFromZone(pd.end_time)}
            <span style={{ backgroundColor:eventData.primary_color }}>
            <i
            className={
            activePanel === key
            ? "icon-up-open-2"   // when active (expanded)
            : "icon-down-open-2" // when collapsed
            }
            ></i>
            </span>
          </div>
          <div className="info" style={{ borderLeft:'2px solid' + eventData.primary_color }}>
            <h3  style={{ color:eventData.primary_color }}>{UserHelper.getEventTitle(pd.translations)}</h3>
            <p className="name">
              <strong className="strongP" style={{ color:eventData.primary_color }}>{UserHelper.getEventModerator(pd)}  </strong>
              <br/>{UserHelper.getModeratorProfession(pd)}
               <br />






               {activePanel !== key && (
    <div
      onClick={() =>
        setActivePanel(activePanel === key ? null : key)
      }
    >
      <a href="#_" className="about-more" style={{ color:eventData.primary_color }}>
        More
        <i className="icon-right-open"></i>
      </a>
    </div>
  )}



               
              
               
            </p>

            {activePanel === key && (
              <div className="caption">
                <div className="image-area">
                  <img
                    src={UserHelper.getModeratorPicture(pd)}
                    alt="speaker"
                    width="150"
                  />
                </div>
                <div className="text-area">
                  <p
                    dangerouslySetInnerHTML={{
                      __html: UserHelper.getEventDescription(pd),
                    }}
                  />
                </div>
              </div>
            )}
            <hr />
          </div>
        </div>
      ))}
    </div>
  )}

  {/* Display Center */}
  {_.size(displayCenter) > 0 && (
    <div className="event-section">
      <h2 className="section-heading">3D-Display Center</h2>
      {_.map(displayCenter, (pd, key) => (
        <div
          key={key}
          className={`event ${activeDisplayCenter === key ? "extend" : ""}`}
        >
          <div
            className="time"
            onClick={() => setActivePanel(activeDisplayCenter === key ? null : key)}
            style={{ color:eventData.primary_color }}
          >
            {UserHelper.localTimeStrFromZone(pd.start_time)} -{" "}
            {UserHelper.localTimeStrFromZone(pd.end_time)}
            <span style={{ backgroundColor:eventData.primary_color }}>
            <i
            className={
            activeDisplayCenter === key
            ? "icon-up-open-2"   // when active (expanded)
            : "icon-down-open-2" // when collapsed
            }
            ></i>
            </span>
          </div>
          <div className="info" style={{ borderLeft:'2px solid' + eventData.primary_color }}>
            <h3  style={{ color:eventData.primary_color }}>{UserHelper.getEventTitle(pd.translations)}</h3>
            <p className="name">
              {pd.presenters && pd.presenters.length > 0 && (
                pd.presenters.map((p, index) => (
              <div key={index}>
                <strong className="strongP" style={{ color: eventData.primary_color }}>
                  
                  {UserHelper.getEventPresentor(p)}
                </strong>
                <br />
                {UserHelper.getPresentorProfession(p)}
              </div>
            ))
          )}

               <br />


               {activeDisplayCenter !== key && (
    <div
      onClick={() =>
        setActiveDisplayCenter(activeDisplayCenter === key ? null : key)
      }
    >
      <a href="#_" className="about-more" style={{ color:eventData.primary_color }}>
        More
        <i className="icon-right-open"></i>
      </a>
    </div>
  )}


               
            </p>

            {activeDisplayCenter === key && (
              <div className="caption">
                
                <div className="text-area">
                  <p
                    dangerouslySetInnerHTML={{
                      __html: UserHelper.getEventDescription(pd),
                    }}
                  />
                </div>
              </div>
            )}
            <hr />
          </div>
        </div>
      ))}
    </div>
  )}

  {/* On Demand */}
  {_.size(onDemand) > 0 && (
    <div className="event-section">
      <h2 className="section-heading">On-Demand</h2>
      {_.map(onDemand, (od, key) => (
        <div
          key={key}
          className={`event ${activeOnDemand === key ? "extend" : ""}`}
        >
          <div
            className="time"
            style={{ color:eventData.primary_color }}
            onClick={() =>
              setActiveOnDemand(activeOnDemand === key ? null : key)
            }
            
          >
            {UserHelper.localTimeStrFromZone(od.start_time)} -{" "}
            {UserHelper.localTimeStrFromZone(od.end_time)}
            <span style={{ backgroundColor:eventData.primary_color }}>
            <i
            className={
            activeOnDemand === key
            ? "icon-up-open-2"   // when active (expanded)
            : "icon-down-open-2" // when collapsed
            }
            ></i>
            </span> 
          </div>
          <div className="info" style={{ borderLeft:'2px solid' + eventData.primary_color }}>
            <h3 style={{ color:eventData.primary_color }}>{UserHelper.getEventTitle(od.translations)}</h3>
            <p className="name">
              <strong className="strongP" >{UserHelper.getEventSpeaker(od)}  </strong>
              <br/>{UserHelper.getSpeakerProfession(od)}
             
            </p>
            {activeOnDemand === key && (
              <div className="caption">
                <div className="image-area">
                  <img
                    src={UserHelper.getSpeakerPicture(od)}
                    alt="speaker"
                    width="150"
                  />
                </div>
                <div className="text-area">
                  <p
                    dangerouslySetInnerHTML={{
                      __html: UserHelper.getEventDescription(od),
                    }}
                  />
                </div>
              </div>
            )}
            <hr />
          </div>
        </div>
      ))}
    </div>
  )}
</div>


      );
};

export default LandingPageSchedules;